export const CACHE_TTL_MS = 2 * 60 * 1000;

export interface CacheEntry<T> {
  value: T;
  cachedAt: number;
}

export const isCacheValid = <T>(entry: CacheEntry<T> | undefined): entry is CacheEntry<T> => {
  if (!entry) return false;
  return Date.now() - entry.cachedAt < CACHE_TTL_MS;
};